import type { ParsedUrlQuery } from 'querystring';

/**
 * Get the hash of the filters to use as a key for caching, detecting filters changes, etc.
 */
export function getFiltersHash(filtersQueryParams: ParsedUrlQuery): string {
    const sortedKeys = Object.keys(filtersQueryParams).sort((a, b) => {
        return a.localeCompare(b);
    });

    const sortedKeyValueList = sortedKeys.reduce((list, key) => {
        const value = filtersQueryParams[key];

        if (value === '') {
            return list;
        }

        if (typeof value === 'string') {
            return list.concat([`${key}=${value}`]);
        }

        if (Array.isArray(value)) {
            const sortedValues = value
                .slice()
                .sort((a, b) => {
                    return a.localeCompare(b);
                })
                .map((value) => {
                    return `${key}=${value}`;
                });

            return list.concat(sortedValues);
        }

        return list;
    }, [] as Array<string>);

    return sortedKeyValueList.join('&');
}
